import React, { useEffect, useState } from 'react';
import CompaniesView from './CompaniesView';
import { BE_URL, httpGet } from '../../../http';

const Companies = (props) => {

    useEffect(() => {
        if(!sessionStorage.getItem('adminUser')){
            props.history.push('/admin-login');
            return 0;
        }

        getCompanies();
    }, []);

    const [ data, setData ] = useState({
        empresas: [],
        loading: false,
        error: false,
        errorMsg: ''
    });

    const getCompanies = async () => {
        try{
            setData({
                ...data,
                loading: true
            });
    
            let companies = await httpGet(BE_URL + '/ProveedoresWS/api/empresa');
            console.log("COMPANIES");
            console.log(companies);
            if(companies){
                setData({
                    ...data,
                    empresas: companies.data,
                    loading: true
                }); 
            }
        } catch(error){
            setData({
                ...data,
                loading: false,
                error: true,
                erroMsg: 'Ocurrio un error!'
            });
        }
    }

    const handleClick = (id) => {
        console.log("CLICK!");
        sessionStorage.setItem('adminCompanyId', JSON.stringify(id));
        props.history.push('/admin');
    }

    return(<CompaniesView data={data} onClick={handleClick} />);
}

export default Companies;